import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-mobile-notification-form',
  standalone: false,
  templateUrl: './mobile-notification-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mobile-notification-form.component.css'
})
export class MobileNotificationFormComponent {
  @Input() orderId: string = null;
  @Input() userToken: string = null;
  @Input() title: string = "";
  @Input() message: string = "";
  @Input() payload: string = "";
  isLoading: boolean = false;
  form: UntypedFormGroup;
  selectedType: string = null;
  typeOptions: any[] = [
    { value: "DepartureFlightUpdated", viewValue: "Departure Flight Updated", translation: "MOBILE_NOTIFICATION.TYPES.FLIGHT_UPDATED" },
    { value: "ArrivalFlightUpdated", viewValue: "Arrival Flight Updated", translation: "MOBILE_NOTIFICATION.TYPES.FLIGHT_UPDATED" },
    { value: "DepartureFlightCancelled", viewValue: "Departure Flight Cancelled", translation: "MOBILE_NOTIFICATION.TYPES.FLIGHT_CANCELLED" },
    { value: "ArrivalFlightCancelled", viewValue: "Arrival Flight Cancelled", translation: "MOBILE_NOTIFICATION.TYPES.FLIGHT_CANCELLED" },
    { value: "DepartureFlightDelayed", viewValue: "Departure Flight Delayed", translation: "MOBILE_NOTIFICATION.TYPES.FLIGHT_DELAYED" },
    { value: "ArrivalFlightDelayed", viewValue: "Arrival Flight Delayed", translation: "MOBILE_NOTIFICATION.TYPES.FLIGHT_DELAYED" },
    { value: "ShuttleEdited", viewValue: "Shuttle Edited", translation: "MOBILE_NOTIFICATION.TYPES.SHUTTLE_EDITED" },
    { value: "TransferArrivalBoarded", viewValue: "Transfer Arrival Boarded", translation: "MOBILE_NOTIFICATION.TYPES.TRANSFER_ARRIVAL_BOARDED" },
    { value: "TransferDepartureBoarded", viewValue: "Transfer Departure Boarded", translation: "MOBILE_NOTIFICATION.TYPES.TRANSFER_DEPARTURE_BOARDED" },
    { value: "TransferArrivalDropped", viewValue: "Transfer Arrival Dropped", translation: "MOBILE_NOTIFICATION.TYPES.TRANSFER_ARRIVAL_DROPPED" },
    { value: "TransferDepartureDropped", viewValue: "Transfer Departure Dropped", translation: "MOBILE_NOTIFICATION.TYPES.TRANSFER_DEPARTURE_DROPPED" },
    { value: "ParkingCheckin", viewValue: "Order Parking Checkin", translation: "MOBILE_NOTIFICATION.TYPES.ORDER_PARKING_CHECKIN" },
    { value: "ParkingCheckout", viewValue: "Order Parking Checkout", translation: "MOBILE_NOTIFICATION.TYPES.ORDER_PARKING_CHECKOUT" },
    { value: "ParkingSpotAssigned", viewValue: "Parking Spot Assigned", translation: "MOBILE_NOTIFICATION.TYPES.PARKING_SPOT_ASSIGNED" },
    { value: "WelcomeHome", viewValue: "Welcome Home", translation: "MOBILE_NOTIFICATION.TYPES.WELCOME_HOME" },
    { value: "ParkingEdited", viewValue: "Parking Edited", translation: "MOBILE_NOTIFICATION.TYPES.PARKING_EDITED" },
    { value: "PaymentDone", viewValue: "Payment Done", translation: "MOBILE_NOTIFICATION.TYPES.PAYMENT_DONE" },
    { value: "CheckinSoon", viewValue: "Checkin Soon", translation: "MOBILE_NOTIFICATION.TYPES.CHECKIN_SOON" },
    { value: "FlightLanded", viewValue: "Flight Landed", translation: "MOBILE_NOTIFICATION.TYPES.FLIGHT_LANDED" },
    { value: "FirstBaggage", viewValue: "First Baggage", translation: "MOBILE_NOTIFICATION.TYPES.FIRST_BAGGAGE" },
  ];

  constructor(
    private fb: FormBuilder,
    private backOfficeService: BackOfficeService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<MobileNotificationFormComponent>,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.orderId = this.dialogData.orderId;
    this.initialiseForm();
    this.userToken = this.dialogData.userToken;
  }

  initialiseForm() {
    this.form = this.fb.group({
      title: [this.title],
      message: [this.message],
      payload: [this.payload],
      type: [this.selectedType]
    });
  }

  sendNotification() {
    if (this.form.valid) {
      this.isLoading = true;
      this.backOfficeService.sendMobileNotification(
        this.userToken,
        this.orderId,
        this.form.value.title,
        this.form.value.message,
        this.form.value.payload,
        this.form.value.type
      )
        .subscribe({
          next: (response) => {
            this.dialogRef.close();
            this.isLoading = false;
          },
          error: (error) => {
            console.error(error);
            this.dialogRef.close();
            this.isLoading = false;
            this.snackBar.open('Error sending notification', 'Close', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          }
        });
    }
  }
}

